import { createSlice }                  from '@reduxjs/toolkit';
import * as organisationInvoiceReducers from 'Redux/Reducers/OrganisationInvoice';
import { OrganisationInvoice }          from 'Domain/Models';

export interface IOrganisationInvoiceState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  entries: Record<string, OrganisationInvoice>,
  lastUpdateId: string | null,
  maxCount: number,
}

export const organisationInvoiceSlice = createSlice({
  name: 'organisationInvoice',
  initialState: {
    openRequests: [],
    failedRequests: [],
    entries: {},
    maxCount: 0,
    lastUpdateId: null,
    updatedAt: 0,
  },
  reducers: organisationInvoiceReducers,
});
